import React from 'react';
import { Helmet } from 'react-helmet-async';
import Content from './Content';

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Nirantara - ESG & Sustainability Consulting Offices</title>
        <meta name="description" content="Get in touch with Nirantara for ESG consulting, sustainability strategy, CBAM, LCA, and environmental advisory. Reach our India and global offices for tailored sustainability solutions." />
        <meta name="keywords" content="contact Nirantara, ESG consulting contact, sustainability consulting offices, Nirantara India office, ESG advisory contact, sustainability expert contact, ESG consultant reach" />
        <link rel="canonical" href="https://nirantara.solutions/contact-us" />
      </Helmet>
      <h1 className="sr-only">Contact Us</h1>
      <Content />
    </>
  );
}

export default Contact;

